// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { InvoicesDataViewContext } from "@insite/client-framework/Store/Data/Invoices/InvoicesSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { Typography } from "@insite/mobius/index";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import myAccountFilterSectionStyles from "@werner/App/SharedStyle/MyAccount/List/MyAccountFilterSectionStyles";
import { pluralize } from "@werner/XDL/Utilities";
import React from "react";
import { useContext } from "react";
import { css } from "styled-components";

type Props = WidgetProps;

export interface InvoiceHistoryResultsCountStyles {
    wrapper?: InjectableCss;
    invoiceCountText?: TypographyPresentationProps;
}

const invoiceHistoryResultsCountStyles: InvoiceHistoryResultsCountStyles = {
    wrapper: {
        css: css`
            display: flex;
            margin-bottom: 4px;
        `,
    },
    invoiceCountText: {
        ...myAccountFilterSectionStyles.resultCountTextStyles,
    },
};
const styles = invoiceHistoryResultsCountStyles;

const InvoiceHistoryResultsCount = (props: Props) => {
    const invoicesDataView = useContext(InvoicesDataViewContext);
    const invoicesCount =
        invoicesDataView.value && invoicesDataView.pagination ? invoicesDataView.pagination.totalItemCount : 0;

    return invoicesCount > 0 ? (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.invoiceCountText}>
                {`${invoicesCount} ${translate(pluralize(invoicesCount, "Invoice"))}`}
            </Typography>
        </StyledWrapper>
    ) : null;
};

const widgetModule: WidgetModule = {
    component: InvoiceHistoryResultsCount,
    definition: {
        group: "Invoice History",
        displayName: "Invoice History Results Count",
        allowedContexts: ["InvoiceHistoryPage"],
    },
};

export default widgetModule;
